(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  /*
   * Dynamic header crossover. With a dropdown/mega desktop menu, the drawer
   * (hamburger) is normally retired at 990px; this controller additionally
   * collapses the inline nav to it at any width where its links would wrap to
   * a second line, and restores the inline nav once they fit again. Purely
   * measurement-driven — the same header link list behaves identically on any
   * device. The 990px crossover itself is untouched.
   */
  (function () {
    var DESKTOP_MQ = '(min-width: 990px)';

    function measureWraps(header) {
      var nav = header.querySelector(':scope > .header__inline-menu');
      if (!nav) return null;
      var list = nav.querySelector(':scope > ul.list-menu--inline');
      var items = list ? list.children : [];
      if (items.length < 2) return false;
      // Wrapped rows show at the end of the list: flex fills rows in order, so
      // only the last item is guaranteed to sit on the highest row index.
      return items[items.length - 1].offsetTop - items[0].offsetTop > 1;
    }

    /*
     * HeaderDrawer exposes no external close, and at >=990px `overflow-hidden-tablet`
     * resolves to `overflow: auto` (base.css), so an open drawer left behind on a
     * wide-enough resize would release the scroll lock while staying visible under
     * `display: none`. Close it the way closeMenuDrawer() would, without focus
     * restoration (the summary is display:none by now).
     */
    function closeDrawer(header) {
      var drawer = header.querySelector('header-drawer');
      var details = drawer && drawer.querySelector('details');
      if (!details || !details.hasAttribute('open')) return;

      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      details.querySelectorAll('details[open]').forEach((openDetail) => {
        openDetail.removeAttribute('open');
        openDetail.classList.remove('menu-opening');
      });
      drawer.querySelectorAll('.submenu-open').forEach((submenu) => submenu.classList.remove('submenu-open'));

      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');

      /* Parity with HeaderDrawer.closeMenuDrawer */
      if (drawer.onResize) window.removeEventListener('resize', drawer.onResize);

      var section = header.closest('.section-header');
      if (section) section.classList.remove('menu-open');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
    }

    /* Sticky-header keeps `--header-height` fresh only on its own listeners; our
       collapse changes the header height at >=990px, so refresh it on every flip. */
    function refreshHeaderHeight() {
      var section = document.querySelector('.section-header');
      if (section) document.documentElement.style.setProperty('--header-height', `${section.offsetHeight}px`);
    }

    function update(header) {
      if (!window.matchMedia(DESKTOP_MQ).matches) {
        header.classList.remove('nav-overflow');
        return;
      }

      var section = header.closest('.section-header');
      // Frozen while sticky-scrolled: `scrolled-past-header` (reduce-logo-size)
      // shrinks the heading, which would otherwise flip the layout on every
      // scroll past the header instead of on viewport changes.
      if (section && section.classList.contains('scrolled-past-header')) return;

      var wasCollapsed = header.classList.contains('nav-overflow');
      // Measure with the inline nav restored so both states see the same
      // geometry; this stays inside one task, so the transient state that shows
      // them side by side or floods the viewport is never painted.
      header.classList.remove('nav-overflow');
      var wraps = measureWraps(header);
      if (wraps === null) return;

      header.classList.toggle('nav-overflow', wraps);
      /* closeDrawer() no-ops unless the drawer is open; the drawer can be open
         here even with the class already off — e.g. it was opened below 990 and
         the viewport re-crossed upward — and it would otherwise stay open
         (data-breakpoint="desktop" keeps the body scroll-locked) with the nav
         freshly restored underneath it. */
      if (!wraps) closeDrawer(header);
      if (wraps === wasCollapsed) return;
      refreshHeaderHeight();
    }

    function init(header) {
      if (header.dataset.navOverflowWired) return;
      var nav = header.querySelector(':scope > .header__inline-menu');
      if (!nav) return; // drawer-type menu and/or no menu — nothing to collapse
      header.dataset.navOverflowWired = 'true';

      // Header box reacts to viewport width; the nav's own box reacts to
      // changes that don't move the header (a wrap whose literals don't change
      // the header, the cart count bubble growing the icons column) and to the
      // display flips this controller itself makes, which keeps updates flowing
      // while collapsed.
      var headerObserver = new ResizeObserver(() => update(header));
      headerObserver.observe(header);
      var navObserver = new ResizeObserver(() => update(header));
      navObserver.observe(nav);

      var desktopMq = window.matchMedia(DESKTOP_MQ);
      desktopMq.addEventListener('change', () => update(header));

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => update(header));
      }
    }

    var boot = () => document.querySelectorAll('.section-header .header').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.section-header .header').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
